const toggleMiniCartState = (state) => {
    const miniCart = document.querySelector('.mini-cart');
    const miniCartEmptyState = miniCart.querySelector('.mini-cart__empty-state');
    if (miniCartEmptyState) {
        miniCartEmptyState.style.display = state === 'empty' ? 'block' : 'none';
    }
    const miniCartFooter = miniCart.querySelector('.mini-cart__footer');
    if (miniCartFooter) {
        miniCartFooter.style.display = state === 'empty' ? 'none' : 'block';
    }
};

class MiniCartItem extends HTMLElement {
    static get observedAttributes() {
        return ['loading', 'image', 'title', 'productId', 'quantity', 'url', 'variantId'];
    }

    constructor() {
        super();
    }

    get image() {
        return `${this.getAttribute('image')}&width=300&height=300`;
    }

    get loading() {
        return this.getAttribute('loading');
    }

    get productId() {
        return this.getAttribute('product-id');
    }

    get sellingPlanId() {
        return this.getAttribute('selling-plan-id');
    }

    get sellingPlanName() {
        return this.getAttribute('selling-plan-name');
    }

    get quantity() {
        return this.getAttribute('quantity');
    }

    get title() {
        return this.getAttribute('title');
    }

    get url() {
        return this.getAttribute('url');
    }

    get variantId() {
        return this.getAttribute('variant-id');
    }

    set loading(value) {
        this.setAttribute('loading', value);
    }

    set quantity(value) {
        this.setAttribute('quantity', value);
    }

    connectedCallback() {
        const template = `
            <div class="product-snippet" data-content="cart-item">
                <a href="${this.url}" class="product-snippet__media">
                    <img class="product-snippet__image" src="${this.image}" alt="${
            this.title
        }" width="250" height="250">
                </a>
                <div class="product-snippet__content">
                    <a href="${this.url}" class="product-snippet__title">
                        ${this.title}${this.sellingPlanName ? ' - ' + this.sellingPlanName : ''}
                    </a>
                    <div class="product-snippet__quantity-input quantity-input">
                        <div class="quantity-input__inner-wrapper">
                            <button class="quantity-input__minus" data-action="decrease-quantity">-</button>
                            <div class="quantity-input__input-wrapper">
                                <input class="quantity-input__input" type="number" value="${this.quantity}">
                            </div>
                            <button class="quantity-input__plus" data-action="increase-quantity">+</button>
                        </div>
                    </div>
                    <div class="product-snippet__remove-wrapper">
                        <button type="button" class="btn btn--link btn--regular product-snippet__remove" data-action="remove-item">
                            Remove
                        </button>
                    </div>
                </div>
            </div>
        `;

        // Insert template
        this.innerHTML = template;

        // Add class
        this.classList.add('mini-cart-item');

        this.addEventListener('click', (e) => {
            e.preventDefault();
            const isDecreaseQuantity = e.target.closest('[data-action="decrease-quantity"]');
            const isIncreaseQuantity = e.target.closest('[data-action="increase-quantity"]');
            const isRemoveItem = e.target.closest('[data-action="remove-item"]');
            if (isDecreaseQuantity) this.updateQuantity('decrease');
            if (isIncreaseQuantity) this.updateQuantity('increase');
            if (isRemoveItem) this.updateQuantity('remove');
        });
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
        if (attrName === 'quantity') {
            const quantityInput = this.querySelector('.quantity-input__input');
            if (quantityInput) {
                quantityInput.value = newVal;
            }
        }
    }

    updateQuantity(method) {
        this.loading = true;

        let currentQuantity = parseInt(this.quantity);
        if (method === 'increase') {
            currentQuantity = currentQuantity + 1;
        } else if (method === 'decrease') {
            currentQuantity = currentQuantity > 0 ? currentQuantity - 1 : 0;
        } else if (method === 'remove') {
            currentQuantity = 0;
        }

        const body = JSON.stringify({
            id: this.variantId,
            quantity: currentQuantity,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                const cartItemCount = parsedState.item_count;

                // Update Line Item Quantity Box
                if (currentQuantity > 0) {
                    this.quantity = parsedState.items.find(
                        (item) => item.product_id == parseInt(this.productId)
                    ).quantity;
                    this.loading = false;
                } else {
                    // If lowering the quantity makes it become 0, then remove the item entirely
                    this.remove();
                }

                // Update Cart Count
                const cartItemCountEls = document.querySelectorAll('[data-content="cart-item-count"]');
                if (cartItemCountEls.length) {
                    cartItemCountEls.forEach((cartItemCountEl) => (cartItemCountEl.textContent = cartItemCount));
                }

                if (!cartItemCount) {
                    toggleMiniCartState('empty');
                }

                const freeShipping = document.querySelector('.mini-cart free-shipping');
                if (freeShipping) {
                    freeShipping.setAttribute('cart-subtotal', parsedState.items_subtotal_price);
                }
            })
            .catch((e) => {
                console.log('error', e);
                // TODO: Handle error
                this.loading = false;
            });
    }
}

customElements.define('mini-cart-item', MiniCartItem);
